import CompraServicoModal from './CompraServicoModal';

export default CompraServicoModal;
